import Loader from "components/Loader";
import PostModal from "components/TimelinePostList/TimelinePost/PostModal";
import React, { useState, useEffect } from "react";
import { useTeamActionContext } from "store/contexts/teamActionContext";
import { useTeamContext } from "store/contexts/teamContext";
import { TimelineContext } from "store/contexts/timelineContext";
import InnovationVistaPostItem from "views/Teams/InnovationVistaDashboard/InnovationVistaPostItem";
import InfiniteScroll from "react-infinite-scroll-component";
import * as timelineActions from "reteamStore/actions";
import { useSelector, useDispatch } from "react-redux";
import Button from "components/CustomButton";

function InnovationVistaDashboard() {
	const { isLoading, total, page, companyData } = useSelector(
		(state) => state.companyReducer
	);
	const dispatch = useDispatch();
	const { teamId, allCompanyDashboard } = useTeamActionContext();
	const { team } = useTeamContext();
	const [hide, setHide] = useState(false);
	const [selectedPost, setSelectedPost] = useState(null);
	const LoaderStyle = {
		display: "flex",
		justifyContent: "center",
	};

	useEffect(() => {
		(async () => {
			try {
				await allCompanyDashboard();
			} catch (e) {
				console.log(e);
			}
		})();

		return () => {
			console.log('here it is');
			dispatch(timelineActions.clearCompanyData());
		}

		//eslint-disable-next-line
	},[])

	const getNextPageData = () => {
		allCompanyDashboard(page + 1);
		dispatch(timelineActions.companyPageIncreament());
	};

	const LoadingContainer = (
		<>
			{isLoading && (
				<h4>
					<Loader loaderStyle={LoaderStyle} />
				</h4>
			)}
			{!isLoading && (
				<div className="poll-load-more">
					<Button buttonClass="grad_btn w-50 h-50" onClick={getNextPageData}>
						Load More
					</Button>
				</div>
			)}
		</>
	);

	const selectPost = (post) => {
		setSelectedPost(post);
	};

	const closeModal = () => {
		if (hide) setHide(false);
		setSelectedPost(false);
	};

	const updatePost = (post) => {
		dispatch(timelineActions.updateCompanyPost(post));
		if (!selectedPost) return;
		selectPost(post);
	};

	return (
		<TimelineContext.Provider
			value={{
				teamId,
				updatePost,
				selectPost,
				setHide,
				selectedPost,
				innovation_dashboard: true,
				company_id: team?.company?.id
			}}
		>
			<div className="innovationVistaPostContainer">
				<InfiniteScroll
					style={{
						overflow: "hidden",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
					}}
					dataLength={total ?? 0}
					next={getNextPageData}
					hasMore={companyData.length !== total}
					loader={LoadingContainer}
					scrollableTarget="main-panel-right"
					endMessage={
						<p style={{ textAlign: "center" }}>
							{total > 0 && <b>Keep Engaging! </b>}
						</p>
					}
				>
					<InnovationVistaPostItem companyData={companyData} total={total} isCompanyExist={team?.company ? true : false} />
				</InfiniteScroll>
			</div>
			<PostModal
				hide={hide}
				post={selectedPost}
				open={selectedPost}
				close={closeModal}
			/>
		</TimelineContext.Provider>
	);
}

export default InnovationVistaDashboard;
